import React, { useState } from "react";

//Assets 
import LogoCol from "../img/logo_colsubsidio.png";
import MainBk from "../img/zonas_verdes/3.Fondo-ZonasVedes.jpg";
import ImageZonasVerdes from "../img/zonas_verdes/3.Capsula-ZV-ZonasVerdes.jpg";
import ImageCicloRutas from "../img/zonas_verdes/3.Capsula-ZV-CicloRutas.jpg";
import ImageParques from "../img/zonas_verdes/3.Capsula-ZV-Parques.jpg";

//Data Display
import TopLeftTitle from "../data_display/TopLeftTitle";
import ButtonLeftTitle from "../data_display/BottomLeftTitle";
import MiniaturePreview from "../data_display/MiniaturePreview";
import PointDefault from "../data_display/PointLocation";

//Inputs
import HomeButton from "../inputs/HomeButton";

//Navigation
import MenuMiniatures from "../navigation/MenuMiniatures";

const listMiniatures = [{
    id: "1",
    title:"18.829 m²",
    subtitle:"Zonas Verdes",
    image: ImageZonasVerdes,
    x: "66%",
    y: "34%"
}, {
    id: "2",
    title:"3.237 ml",
    subtitle:"Ciclorutas",
    image: ImageCicloRutas,
    x: "22%",
    y: "48%"
}, {
    id: "3",
    title:"50.671 m²",
    subtitle:"Parques",
    image: ImageParques,
    x: "48%",
    y: "37%"
}];

export default function ZonasVerdesPage () {
    const [currentItem, SetCurrentItem] = useState(0);

    function onClickMiniature(tmpIndex)
    {
        SetCurrentItem(tmpIndex);
    }

    return (
        <div style={{width:"100%", height:"100%", backgroundImage:"url("+MainBk+")", backgroundSize:"contain"}}>
            <div style={{position:"absolute", right:"80px", top:"20px", width:"200px"}}>
                <img src={LogoCol} style={{width:"100%"}}/>
            </div>
            <TopLeftTitle title={"ZONAS VERDES"} subtitle={"ÁREAS DE RECREACIÓN Y ESPACIO PÚBLICO"} />
            <ButtonLeftTitle title={"81.912 m²"} subtitle={"Zonas Verdes"} />
            <HomeButton/>
            <MiniaturePreview item={listMiniatures[currentItem]}/>
            <MenuMiniatures items={listMiniatures} selected={currentItem} onClick={onClickMiniature}/>
            {
                listMiniatures.map((item, index)=>{
                    return (<PointDefault key={item.id} id={item.id} 
                        x={item.x} y={item.y} index={index}
                        onClick={onClickMiniature}
                        selected={index === currentItem ? true:false}                        
                        />
                    )
                })
            }
        </div>
    );
}